/* eslint-disable no-plusplus */

import {
  GET_FOLDER,
  CLEAR_FOLDER,
  GET_FOLDERS,
  DELETE_FOLDER,
  ADD_FOLDER,
  EDIT_FOLDER,
  GET_FOLDER_DATA,
  ADD_FOLDER_IN_HIERARCHY,
  REMOVE_FOLDER_FROM_HIERARCHY,
  REMOVE_FOLDERS_FROM_HIERARCHY,
  CLEAR_FOLDERS_HIERARCHY,
  GET_STORAGE_FILE,
  DELETE_STORAGE_FILE,
  CLEAR_STORAGE_FILE,
  ADD_STORAGE_FILE,
  CLEAR_STORAGE,
  ADD_FILES_FOR_PASTE,
  CLEAR_FILES_FOR_PASTE,
} from '../actions/storageActions';

const initialState = {
  count: null,
  fetched: null,
  allFolders: [],
  items: [],
  files: [],
  foldersHierarchy: [],
  openedFolderId: null,
  parentFolderId: null,
  openedFolderName: '',
  fetchedFile: null,
  filesForPaste: null,
};

let i = 0;

const mapFolders = item => ({
  id: Date.now() + i++,
  itemId: item.id,
  name: item.fold_name,
  type: item.type,
  owner: item.department,
  createdAt: item.created_at,
});

const mapFiles = item => ({
  id: Date.now() + i++,
  itemId: item.id,
  name: item.doc_name,
  type: item.type,
  owner: '',
  createdAt: item.created_at,
  docType: item.doc_type,
  docFile: item.doc_file,
  category: item.location,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_FOLDER:
      return {
        ...state,
        fetched: action.payload,
      };
    case CLEAR_FOLDER:
      return {
        ...state,
        fetched: null,
      };
    case GET_FOLDERS:
      return {
        ...state,
        count: action.payload.count,
        allFolders: action.payload.results,
      };
    case DELETE_FOLDER:
      return {
        ...state,
        items: state.items.filter(item => item.id !== action.payload),
      };
    case ADD_FOLDER:
      return {
        ...state,
        items: [
          ...state.items,
          {
            id: Date.now() + i++,
            itemId: action.payload.id,
            name: action.payload.fold_name,
            type: action.payload.type,
            owner: action.payload.department,
            createdAt: action.payload.created_at,
          },
        ],
      };
    case EDIT_FOLDER:
      return {
        ...state,
      };
    case GET_FOLDER_DATA:
      return {
        ...state,
        items: [
          ...action.payload.folders.map(mapFolders),
          ...action.payload.storage.map(mapFiles),
        ],
        openedFolderId: action.payload.folder_id,
        openedFolderName: action.payload.folder_name,
        parentFolderId: action.payload.parent_folder_id,
      };
    case GET_STORAGE_FILE:
      return {
        ...state,
        fetchedFile: action.payload,
      };
    case ADD_STORAGE_FILE:
      return {
        ...state,
        items: [
          ...state.items,
          {
            id: Date.now() + i++,
            itemId: action.payload.id,
            name: action.payload.doc_name,
            type: action.payload.type,
            owner: '',
            createdAt: action.payload.created_at,
            docType: action.payload.doc_type,
            docFile: action.payload.doc_file,
            category: action.payload.location,
          },
        ],
      };
    case DELETE_STORAGE_FILE:
      return {
        ...state,
        items: state.items.filter(item => item.id !== action.payload),
      };
    case CLEAR_STORAGE_FILE: {
      return {
        ...state,
        fetchedFile: null,
      };
    }
    case CLEAR_STORAGE:
      return {
        ...state,
        folders: [],
        files: [],
        foldersHierarchy: [],
        openedFolderId: null,
        parentFolderId: null,
        openedFolderName: '',
        fetchedFile: null,
      };
    case ADD_FOLDER_IN_HIERARCHY:
      return {
        ...state,
        foldersHierarchy: [...state.foldersHierarchy, action.payload],
      };
    case REMOVE_FOLDER_FROM_HIERARCHY:
      return {
        ...state,
        foldersHierarchy: state.foldersHierarchy.filter(
          item => item.id !== action.payload
        ),
      };
    case REMOVE_FOLDERS_FROM_HIERARCHY:
      return {
        ...state,
        foldersHierarchy: state.foldersHierarchy.filter(
          (_, index) => index <= action.payload
        ),
      };
    case CLEAR_FOLDERS_HIERARCHY:
      return {
        ...state,
        foldersHierarchy: [],
      };
    case ADD_FILES_FOR_PASTE:
      return {
        ...state,
        filesForPaste: action.payload,
      };
    case CLEAR_FILES_FOR_PASTE:
      return {
        ...state,
        filesForPaste: null,
      };
    default:
      return state;
  }
};
